import { render, staticRenderFns } from "./PersonalRelations.vue?vue&type=template&id=595ba536&scoped=true&"
import script from "./PersonalRelations.vue?vue&type=script&lang=ts&"
export * from "./PersonalRelations.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalRelations.vue?vue&type=style&index=0&id=595ba536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595ba536",
  null
  
)

export default component.exports